import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { getQueryStringValue } from '@/helpers/getQueryStringArrayValue'

import { categoryPrefixAt, categoryPrefixOfDepth, PRODUCT_SEGMENTS, TOPIC_SEGMENTS } from './notificationCategoryPrefix'

export const useRouterQueryNotificationCenterCategory = () => {
  const route = useRoute()
  const router = useRouter()

  const topic = computed(() => categoryPrefixOfDepth(getQueryStringValue(route.query.topic) || null, TOPIC_SEGMENTS))
  const product = computed(() =>
    topic.value
      ? categoryPrefixAt(topic.value, PRODUCT_SEGMENTS)
      : categoryPrefixOfDepth(getQueryStringValue(route.query.product) || null, PRODUCT_SEGMENTS),
  )
  const categoryPrefix = computed(() => topic.value ?? product.value)

  function setProduct(value: string | null) {
    router.push({ query: { ...route.query, product: value ?? undefined, topic: undefined } })
  }

  function setTopic(value: string | null) {
    router.push({ query: { ...route.query, topic: value ?? undefined } })
  }

  return { product, topic, categoryPrefix, setProduct, setTopic }
}
